import React from "react";
import './blog.css';

const WebsiteDev = () => {
  
 const videos = [
    {
      id: 1,
      title: "Responsive Sidebar Menu collapse and Expand Html Css - Codingwithssr",
      url: "https://www.youtube.com/watch?v=tkhS_pbB7Kg",
    },
    {
      id: 2,
      title: "Introduction About Codingwithssr | Sivasundararaj | Who I am - Codingwithssr",
      url: "https://www.youtube.com/watch?v=kfU3iWe5ei4",
    },
    {
      id: 3,
      title: "Responsive Menu #Codingwithssr #Sivasundararaj #responsivemenu #frontend #uiux #learning #tutorial - Codingwithssr",
      url: "https://www.youtube.com/shorts/ZnCoSoUtgII",
    },
    {
      id: 4,
      title: "Responsive Profile Design | Codingwithssr- Codingwithssr",
      url: "https://www.youtube.com/shorts/XkuLv6VNaUU",
    },
     {
      id: 5,
      title: "Tour Card Design with Custom Api #uiux #frontenddevelopment - Codingwithssr",
      url: "https://www.youtube.com/shorts/RVL1eBu2pew",
    },
     {
      id: 6,
      title: "our team card design #ourteamcarddesign #Codingwithssr - Codingwithssr",
      url: "https://www.youtube.com/shorts/sCWrw4m5TFQ",
    },
     {
      id: 7,
      title: "MyRecipeTips #Codingwithssr #Sivasundararaj - Codingwithssr",
      url: "https://www.youtube.com/shorts/ZB6HHq9W0ds",
    },
    {
      id: 8,
      title: "Travel Info Card Design | Codingwithssr - Codingwithssr",
      url: "https://www.youtube.com/shorts/VowXSZt-Z6c",
    },
    {
      id: 9,
      title: "Tailwindcss Responsive Menu | #codingwithssr, #ui #tailwindcss #responsivedesign #uiux #learning- Codingwithssr",
      url: "https://www.youtube.com/shorts/yyFxCEphiXc",
    }
  ];
  
  return (
      <div id="videoshorts">
      <h1>Website Development Company in Trichy </h1>
      <div className="listidea">
        {videos.map((video) => (
          <div className="listbox" key={video.id}>
            <a href={video.url} target="_blank" rel="noopener noreferrer">
              <div className="iframe-container">
                <iframe
                  src={`https://www.youtube.com/embed/${video.url.split('v=')[1]}`}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <h3>{video.id}. {video.title}</h3>
            </a>
          </div>
        ))}
      </div>
    </div>
  ); 

}
export default WebsiteDev;
